var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-tabs',{attrs:{"value":_vm.selectedTab}},[_c('vs-tab',{attrs:{"label":_vm.tabs[0].label},on:{"click":()=>{ _vm.handleChangeTab(_vm.tabs[0].key) }}},[(_vm.id || _vm.isCreate)?_c('plan-partners-info',{attrs:{"id":_vm.id}}):_c('plan-partner-agreement')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }